<template>
  <div class="intro_wrap">
    <div class="about">
      <div class="title">公司简介<em>Company Profile</em></div>
      <div style="text-align: justify; height: 20px">&nbsp;</div>
      <div class="part1">
        <div style="text-align: justify" class="indent">
          广电计量检测集团股份有限公司（股票简称：广电计量，股票代码：002967）始建于1964年，于2019年11月8日登陆中小企业板， 是广州市国资系统2019年上市第一股，是广州无线电集团旗下的第三家A股上市公司。
        </div>
      </div>
      <div class="part1 pl" style="min-height: 345px">
        <div class="imgDiv" style="text-align: justify">
          <img alt="" src="@/assets/img/intro2.jpg" style="width: 410px" />
        </div>
        <div class="content indent">
          广电计量是原信息产业部电子602计量站，经过50余年的发展，现已成为一家全国化、综合性的国有第三方计量检测机构，专注于为客户提供计量、检测、认证以及技术咨询与培训等专业技术服务，在计量校准、可靠性与环境试验、电磁兼容检测等多个领域的技术能力及业务规模处于国内领先水平。
        </div>
      </div>
      <div class="part1 clearfix">
        <div style="text-align: justify" class="indent">
          广电计量的技术能力获得了众多国内外权威机构和组织的认可和授权，通过了中国合格评定国家认可委员会认可（CNAS），获得检验检测机构资质认定（CMA）、农产品质量安全检测机构（CATL）以及众多政府和行业权威机构的认可资质，是农业部“三品一标”检测实验室、全国土壤污染详查推荐检测实验室、中国CB实验室，出具的证书、报告具有国际公信力，可帮助客户稳健开拓本地市场乃至全球市场。
        </div>
      </div>
      <div class="part2" style="padding-bottom: 50px">
        <div class="content indent" style="text-align: justify">
          广电计量构建了覆盖全国的服务保障网络，在国内建有23个计量检测基地和50多家分子公司，实验室总面积超过16万平方米，配置国内外高端设备仪器15000多台/套，搭建的全国一体化计量检测与认证技术公共服务平台，可迅速响应客户需求，为客户提供近距离、本地化的专业服务。<br />
          <span class="indent"> 广电计量打造了一支技术水平和服务意识俱佳的服务队伍，现有员工4000多人，其中包括各领域专家和技术带头人50多人，博士后、博士30人，硕士380多人。 </span>
        </div>
        <div class="imgDiv" style="text-align: justify">
          <img alt="广电计量检测集团股份有限公司" src="@/assets/img/intro3.jpg" style="width: 415px; height: 284px" />
        </div>
      </div>
      <div style="text-align: justify; height: 40px">&nbsp;</div>
      <div class="part1 pl partw">
        <div class="imgDiv" style="text-align: justify">
          <img alt="实验室" src="@/assets/img/intro1.jpg" style="width: 410px; height: 464px" />
        </div>
        <div class="content">
          <div>
            <p style="text-align: justify" class="indent">
              广电计量建有技术研究院，在新能源汽车、轨道交通、无线通信等领域，先后主持编写30多项国家级和地方计量测试标准及规程，承担50多项国家、省部级等重点科研项目，累计获得专利授权247项，另获得软件著作权119项，积极推动了行业新技术的创新和产业化应用。
            </p>
            <p style="text-align: justify" class="indent">
              作为一家拥有高度社会责任感的国有企业，广电计量以助推各区域经济高质量发展、助力企业品质提升为己任。目前，广电计量的服务能力覆盖汽车、航空、轨道交通、船舶、通信、电力、电子电器、食品、环保、农业、医疗、石化等领域，凭借专业的计量检测技术之力，广电计量可帮助各行业产业链上下游客户提升自身竞争力，实现产品全寿命周期的质量管控。
            </p>
            <p style="text-align: justify" class="indent">在品质决胜未来的发展新时代，广电计量将继续秉持科学、公正、准确、快捷、周到的服务理念，为高质量发展传递信任，为建设“和谐美丽”中国保驾护航！</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.intro_wrap {
  margin-top: 30px;
  .indent {
    display: inline-block;
    text-indent: 2rem;
  }
  .about {
    padding: 0px 0 60px 25px;
  }
  .about .title {
    height: 42px;
    border-bottom: #dedede solid 1px;
    color: #5a8cb7;
    font-size: 24px;
  }
  .about .title em {
    padding-left: 38px;
    background: url(../../assets/img/line4.jpg) 20px 2px no-repeat;
    color: #d0dae5; /*text-transform:uppercase;*/
  }
  .about .videoImg {
    padding: 50px 0;
  }
  .about .name1 {
    font-size: 20px;
    color: #00447d;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .about .name2 {
    font-size: 42px;
    color: #ebebeb;
    text-transform: uppercase;
  }
  .about .part1 {
    font-size: 14px;
    line-height: 30px;
    padding: 10px 0 30px;
  }
  .about .part2 {
    padding-right: 456px;
    position: relative;
    min-height: 220px;
  }
  .about .part2 .imgDiv {
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .about .part2 .content {
    font-size: 14px;
    line-height: 30px;
  }
  .about .part3 {
    padding-bottom: 40px;
  }
  .about .part1.pl {
    padding-left: 434px;
    position: relative;
    min-height: 220px;
    padding-top: 20px;
  }
  .about .part1 .imgDiv {
    position: absolute;
    left: 0px;
    top: 20px;
  }
  .partw {
    height: 450px;
  }
}
</style>
